import LsdApiModel from './global/LsdApiModel';

export default class ExpenseMediaModel extends LsdApiModel {
	static get path(): string {
		return '/expense_media/{?id}';
	}
}
